import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Image, Stack, Text } from '@mantine/core';
import { ProfileCharacter } from './ProfileCharacter';
export const ProfileIntro: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack mih={{
    base: 'calc(100vh - 110px)',
    lg: 'calc(100vh - 190px)'
  }} gap={10} bg={{
    sm: 'var(--bg-200)',
    lg: 'transparent'
  }} p={{
    base: 24,
    sm: 20,
    lg: 0
  }}>
      <Image src="/assets/kyc/lock.svg" alt="lock" w={{
      base: 80,
      sm: 100,
      lg: 112
    }} h={{
      base: 80,
      sm: 100,
      lg: 112
    }} />
      <Box>
        <Text fz={{
        sm: 20,
        lg: 32
      }} c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('unlock ')}
          <Text c="var(--text-white)" span inherit>
            {i18n._('your primeorb’s full power!')}
          </Text>
        </Text>
      </Box>

      <Divider size="sm" c="var(--icon-primary)" />

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} style={{
      wordBreak: 'break-word'
    }}>
        {i18n._('Your PrimeOrb is waiting to level up! Complete the verification process to unlock powerful Legendary Armor and boost your rewards. It’s your time to gear up and start reaping the benefits!')}
      </Text>

      <ProfileCharacter visible="sm" hidden="lg" />
    </Stack>;
};